module.exports = __webpack_public_path__ + "media/images/checkmark-c1a18103.png";